import React, { PropTypes, Component } from 'react'

import './AddressForm.scss'
import Map from 'components/Map'
import Geosuggest from 'components/Geosuggest'
import AddressFormFields from './components/AddressFormFields'

import { convertGoogleMapsPlaceToAliadaLocation } from 'utils/google-maps'

class AddressForm extends Component {
  constructor (props) {
    super(props)

    this.suggestionSelected = this.suggestionSelected.bind(this)
    this.mapChanged = this.mapChanged.bind(this)
    this.addressChanged = this.addressChanged.bind(this)
  }

  suggestionSelected (suggestion) {
    const { coordinates, address } = convertGoogleMapsPlaceToAliadaLocation(suggestion)
    this.updateMap(coordinates)
    this.updateAddress(address)
  }

  mapChanged (center) {
    this.updateMap(center)
  }

  addressChanged (address) {
    this.updateAddress(address)
  }

  updateMap ({ lat, lng }) {
    this.updateValue({
      lat,
      lng
    })
  }

  _filterValidAddressComponents (address) {
    const validAddressComponents = [ 'street', 'number', 'interiorNumber', 'neighborhood', 'state', 'city', 'postal_code_number' ]
    return Object.keys(address)
            .filter(addressComponent => validAddressComponents.includes(addressComponent))
            .reduce((acc, addressComponent) => {
              acc[addressComponent] = address[addressComponent]
              return acc
            }, {})
  }

  updateAddress (address) {
    const result = this._filterValidAddressComponents(address)
    this.updateValue({
      ...result
    })
  }

  updateValue (value) {
    this.props.input.onChange({
      ...this.props.input.value,
      ...value
    })
  }

  render () {
    const {
      lat,
      lng,
      ...address
    } = this.props.input.value

    const location = { lat, lng }

    return (
      <div className='AddressForm'>
        <Map
          location={location}
          address={address}
          onChange={this.mapChanged}
          />

        <div className='AddressForm-geosuggest'>
          <Geosuggest
            placeholder='Escribe tu dirección'
            onSuggestSelect={this.suggestionSelected}
            />
        </div>

        <AddressFormFields
          values={{ ...address }}
          onChange={this.addressChanged}
          error={this.props.meta.error}
          touched={this.props.meta.touched}
          />
      </div>
    )
  }
}

AddressForm.displayName = 'AddressForm'
AddressForm.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired
  }).isRequired
}
AddressForm.defaultProps = {}

export default AddressForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/screens/ServiceAddress/components/AddressForm/AddressForm.js